import { ChangeEvent, useState } from "react";
import { useLazyExportVisitsQuery } from "src/api/visitasApi";
import { ActionButtons } from "src/components/ui/ActionButtons";
import { DateInput } from "src/components/ui/DateInput";
import { useSignalR } from 'src/context/SignalRContext';
import { toast } from "react-toastify";
import { formatDate, subtractDays } from "src/utils/calendarUtils";

type ExportVisitsFilters = {
    fechaInicial: string;
    fechaFinal: string;
    connId?: string;
}

interface Props {
    onClose?: () => void;
}

export function ExportVisitsForm({ onClose }: Props) {
    const { getConnectionId, connectionStatus } = useSignalR();

    const [exportVisits, { isFetching }] = useLazyExportVisitsQuery();

    const [filters, setFilters] = useState<ExportVisitsFilters>({
        fechaInicial: formatDate(subtractDays(new Date(), 7)),
        fechaFinal: formatDate(subtractDays(new Date(), 1)),
    });

    const handleExportVisits = () => {
        const connectionId = getConnectionId();
        if (!connectionId) return;

        toast.info("La exportacion del archivo ha comenzado.", { autoClose: 3000 });
        exportVisits({...filters, connId: connectionId ?? ""});

        if (connectionStatus !== 'connected') {
            alert('SignalR not ready');
            return;
        }

        if (onClose) onClose();
    }

    const onChangeFilters = (event: ChangeEvent<HTMLInputElement>) => {
        setFilters({
            ...filters,
            [event.target.name]: event.target.value
        });
    }

    return (
        <div className="w-[700px] p-3">
            <p className="text-2xl font-semibold">Exportar visitas a Excel</p>

            <div className="grid grid-cols-2 gap-4 w-full py-6">
                <div className="flex flex-col">
                    <label className="font-semibold text-gray-600 text-sm">Fecha inicial</label>
                    <input
                        className="border-gray-300 border-2 rounded text-gray-600 text-center"
                        onChange={onChangeFilters}
                        value={filters.fechaInicial}
                        name="fechaInicial"
                        type="date" />
                </div>

                <div className="flex flex-col">
                    <label className="font-semibold text-gray-600 text-sm">Fecha final</label>
                    <DateInput
                        onChange={onChangeFilters}
                        value={filters.fechaFinal}
                        name="fechaFinal"/>
                </div>
            </div>

            <ActionButtons
                saveButtonType="button"
                saveButtonText="Exportar"
                onSave={handleExportVisits}
                onCancel={onClose}
                isLoading={isFetching}/>
        </div>
    );
}
